export default function($) {
  $(document).ready(function(){
    $('#customKeoleSide8').on('click', function(){
      $(this).addClass('open');
    })

    $('.js-customKeoleSide8-close').on('click', function(event){
      event.stopPropagation()
      $('#customKeoleSide8').removeClass('open active activeMobile force_active')
    })
  })
}
